export const innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
  <path fill="currentcolor" d="m11.08 12 4.828 7.703A9.09 9.09 0 1 1 11.09 2.91L11.08 12Zm10.542.51a8.99 8.99 0 0 1-3.784 7.312l-5.205-7.328 8.989.016ZM12.579 2a9.042 9.042 0 0 1 9.043 9.042h-9.043V2Z" opacity=".9"/>
</svg>
`;
